import { AppointmentDate } from 'components/AppointmentDate/AppointmentDate';
import { formatCurrencyDollars } from 'utils/currency';
import { Button } from 'components/Button';
import { Card } from 'components/Card';
import { Divider } from 'components/Divider';
import { Heading } from 'components/Typography';
import { useTranslation } from 'react-i18next';

type Props = {
  appointmentTitle: string;
  appointmentPrice?: number;
  onEdit?: () => void;
  date: Date;
  className?: string;
};
export const AppointmentDateCard: React.FC<Props> = ({
  date,
  className,
  appointmentTitle,
  appointmentPrice,
  onEdit,
}) => {
  const { t } = useTranslation();

  return (
    <Card className={className}>
      <Heading level="h6" className="mb-24 sm-d:mb-32">
        {t('appointmentDateCard.title')}
      </Heading>

      <div className="flex justify-between items-center mb-16">
        <Heading level="h5" className="font-semibold">
          {appointmentTitle}
        </Heading>

        {onEdit && (
          <Button variant="link" onClick={onEdit} className="sm-d:hidden">
            {t('reservationCard.editButton')}
          </Button>
        )}
      </div>
      <AppointmentDate date={date} />
      {appointmentPrice !== undefined && (
        <div>
          <Divider className="my-40" />
          <div className="flex items-center justify-between">
            <Heading level="h7">{t('reservationCard.appointment.amount')}</Heading>
            <Heading level="h3">{formatCurrencyDollars(appointmentPrice)}</Heading>
          </div>
        </div>
      )}

      {onEdit && (
        <Button variant="link" onClick={onEdit} className="sm:hidden mt-12">
          {t('reservationCard.editButton')}
        </Button>
      )}
    </Card>
  );
};
